import { Permission } from 'interfaces/permissionOption';

export const canQueryUsersEndpoint = (hasPermission: (permission: Permission) => boolean) =>
  hasPermission(Permission.DefineRolesToLabUsers) || hasPermission(Permission.EditStudyAcl);
